import React from "react";

import shapeImg1 from "../../assets/img/choose/shape-1-1.png";
import shapeImg2 from "../../assets/img/choose/shape-1-2.png";
import shapeImg3 from "../../assets/img/choose/shape-1-3.png";
import shapeImg4 from "../../assets/img/choose/shape-1-4.png";
import aboutImage from "../../assets/img/about/ed-about-1-1.jpg";

const WhyChooseUs = () => {
  return (
    <div className="it-choose-area p-relative fix pt-180 pb-110">
      <div className="it-choose-shape-4 d-none d-md-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 mb-30 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-choose-left">
              <h1
                className="it-choose-title-box mb-30"
              >
                Qui sommes-nous
              </h1>

              <div className="it-choose-text pb-15">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum. Sed ut perspiciatis unde omnis
                  iste natus error sit voluptatem accusantium doloremque
                  laudantium, totam rem aperiam, eaque ipsa quae ab illo
                  inventore veritatis et quasi architecto beatae vitae dicta
                  sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                  aspernatur aut odit aut fugit, sed quia consequuntur magni
                  dolores eos qui ratione voluptatem sequi.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 mb-30 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-choose-thumb-box text-center text-lg-end">
              <div className="it-choose-thumb p-relative">
                <img src={aboutImage} alt="Présentation de notre établissement" />
                <div className="it-choose-shape-1">
                  <img src={shapeImg1} alt="" />
                </div>
                <div className="it-choose-shape-2">
                  <img src={shapeImg2} alt="" />
                </div>
                <div className="it-choose-shape-3 d-none d-lg-block">
                  <img src={shapeImg3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WhyChooseUs;
